<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->
        <div class="glist">
            <span class="gname">{{ $t('new.jtit') }}</span>
            <div class="gitem">
                <div class="items" @click="getnavtwo(1)">
                    <img src="@/assets/gd/jone.png" class="jone" alt="">
                    <span>DEX</span>
                </div>
                <div class="items" @click="getnavtwo(1)">
                    <img src="@/assets/gd/jtwo.png" class="jone" alt="">
                    <span>{{ $t('new.done') }}</span>
                </div>
                <div class="items" @click="getnavtwo(1)">
                    <img src="@/assets/gd/jthree.png" class="jone" alt="">
                    <span>{{ $t('new.dtwo') }}</span>
                </div>
                <div class="items" @click="getnavtwo(1)">
                    <img src="@/assets/gd/jfour.png" class="jone" alt="">
                    <span>{{ $t('new.dthree') }}</span>
                </div>
            </div>
        </div>
        <div class="glist">
            <span class="gname">{{ $t('new.stit') }}</span>
            <div class="gitem">
                <div class="items" @click="getnavtwo(1)">
                    <img src="@/assets/gd/sone.png" class="jone" alt="">
                    <span>{{ $t('new.sone') }}</span>
                </div>
                <div class="items" @click="getnavtwo(2)">
                    <img src="@/assets/gd/stwo.png" class="jone" alt="">
                    <span>{{ $t('new.stwo') }}</span>
                </div>
                <div class="items" @click="getnavtwo(3)">
                    <img src="@/assets/gd/sthree.png" class="jone" alt="">
                    <span>{{ $t('new.sthree') }}</span>
                </div>
                <div class="items" @click="getnavtwo(4)">
                    <img src="@/assets/gd/sfour.png" class="jone" alt="">
                    <span>{{ $t('new.sfour') }}</span>
                </div>
                <div class="items" @click="getnavtwo(5)">
                    <img src="@/assets/gd/sfive.png" class="jone" alt="">
                    <span>{{ $t('new.sfive') }}</span>
                </div>
                <div class="items" @click="getnavtwo(6)">
                    <img src="@/assets/gd/ssix.png" class="jone" alt="">
                    <span>{{ $t('new.ssix') }}</span>
                </div>
                <div class="items" @click="getnavtwo(7)">
                    <img src="@/assets/gd/sseven.png" class="jone" alt="">
                    <span>{{ $t('new.sseven') }}</span>
                </div>
                <div class="items" @click="getnavtwo(8)">
                    <img src="@/assets/gd/seight.png" class="jone" alt="">
                    <span>{{ $t('new.seight') }}</span>
                </div>
            </div>
        </div>
        <div class="glist">
            <span class="gname">{{ $t('new.ptit') }}</span>
            <div class="gitem">
                <div class="items" @click="getnavthree(1)">
                    <img src="@/assets/gd/pone.png" class="jone" alt="">
                    <span>{{ $t('new.pone') }}</span>
                </div>
                <div class="items" @click="getnavthree(2)">
                    <img src="@/assets/gd/ptwo.png" class="jone" alt="">
                    <span>{{ $t('new.ptwo') }}</span>
                </div>
                <div class="items" @click="getnavthree(3)">
                    <img src="@/assets/gd/pthree.png" class="jone" alt="">
                    <span>{{ $t('new.pthree') }}</span>
                </div>
                <div class="items" @click="getnavthree(4)">
                    <img src="@/assets/gd/pfour.png" class="jone" alt="">
                    <span>{{ $t('new.pfour') }}</span>
                </div>
                <div class="items" @click="getnavthree(5)">
                    <img src="@/assets/gd/pfive.png" class="jone" alt="">
                    <span>NFT</span>
                </div>
                <div class="items"  @click="getnavthree(6)">
                    <img src="@/assets/gd/psix.png" class="jone" alt="">
                    <span>ICO</span>
                </div>
                <div class="items"  @click="getnavthree(7)">
                    <img src="@/assets/gd/pseven.png" class="jone" alt="">
                    <span>{{ $t('new.pfive') }}</span>
                </div>
            </div>
        </div>

        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="">
        </div>
    </div>
</template>

<script>
import {showToast} from "@/libs/util.js";
export default {
    data() {
        return {
        }
    },
    created() {
    },
    methods:{
        goHome(){
            this.$router.go(-1)
        },
        getnavtwo(e){
            console.log(e)
            let vm = this
            showToast(this.$t("暫未開放"));
        },
        getnavthree(e){
            let vm = this
            if(e == 1){
                localStorage.setItem("homeindex", '1');
                this.$router.push({ path: '/' })
            }else if(e == 2){
                this.$router.push({ path: '/Gonglist' })
            }else if(e == 3){
                this.$router.push({ path: '/Kongtou' })
            }else if(e == 4){
                this.$router.push({ path: '/node' })
            }else if(e == 5){
                this.$router.push({ path: '/NFT' })
            }else if(e == 6){
                this.$router.push({ path: '/ico' })
            }else{
                showToast(vm.$t('no_open'))
                // this.$router.push({ path: '/NFT' })
            }
        }
    }
}
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    padding: 30px 0px;
    .glist{
        margin-bottom: 20px;
    }
    .gname{
        font-weight: bold;
        font-size: 15px;
        color: #1A1A1A;
        display: block;
        margin-bottom: 20px;
        margin-left: 15px;
    }
    .gitem{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .items{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 25%;
            justify-content: center;
            margin-bottom: 20px;
            .jone{
                width: 28px;
                height: 28px;
                margin-bottom: 2px;
            }
            span{
                font-weight: 400;
                font-size: 11px;
                color: #666666;
            }
        }
    }

    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding:  6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
        }
    }

    .mhead{
        // position: relative;
        // top: 50px;
    }
}
</style>
